import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";
import { GroupExpression } from "./GroupExpression";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";
import { RJToken } from "./RJToken";


export class FunctionExpression extends RJExpressionNode
{
  _functionName:RJToken;
  _functionGroup:GroupExpression;

  constructor( parser:RJParser, range:SourceRange = null )
  {
    super( parser, RJExpressionNodeType.FUNCTION, range );
  }

  setFunctionExpression( functionName:RJToken, groupExpression:GroupExpression )
  {
    this._functionName = functionName;
    this._functionName._setParent( this );
    this._functionGroup = groupExpression;
    this._functionGroup._setParent( this );
  }

  cloneNode():FunctionExpression
  {
    let clone = new FunctionExpression( this.parser, this.sourceRange );
    clone.setFunctionExpression( this._functionName.cloneNode(), this._functionGroup.cloneNode() );
    return clone;
  }


  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    let functionName  = new ElementType( "rj-function-name" ).create(  this._functionName.createHTMLElement() );
    let expression = new ElementType( "rj-function-expression" ).create(  this._functionGroup.createHTMLElement() );

    element.appendChild( functionName );
    element.appendChild( expression );

    return element;
  }
}